import { USER_ACCOUNT_LOCAL_STORAGE_KEY, userAccountStore } from '@/stores/userAccountStore';
import { clearUserSession, setUserSession, userSessionStore } from '@/stores/userSessionStore';
import { EntityStoreStatuses } from '@/util/createFetchStore';
import axios from 'axios';
import { LoginParams } from '~/dtos/login_params';
import { API_URL } from '~/modules/config';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '~/modules/constants';
import { selectData, serializeAxiosError } from '~/modules/utilities/axios_utils';

export function authenticateUserSession() {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY) ?? '';
  const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY) ?? '';
  return axios
    .get(`${API_URL}/auth`, {
      headers: {
        Authorization: `Bearer ${accessToken},${refreshToken}`,
      },
    })
    .catch(async function attemptRefresh() {
      return axios.get(`${API_URL}/auth/refresh`);
    })
    .then(selectData);
}

export async function loginUser(params: LoginParams) {
  try {
    userSessionStore.produce((draft) => {
      draft.status = EntityStoreStatuses.LOADING;
    });
    await axios
      .post(`${API_URL}/auth/login`, params)
      .then(selectData)
      .then((userSession) => {
        setUserSession(userSession);
      });
  } catch (error) {
    userSessionStore.produce((draft) => {
      draft.status = EntityStoreStatuses.ERROR;
    });
    return serializeAxiosError(error).message;
  }
}

export async function logoutUser() {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY) ?? '';
  const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY) ?? '';
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_ACCOUNT_LOCAL_STORAGE_KEY);
  const result = await axios.post(`${API_URL}/auth/logout`, {
    headers: {
      Authorization: `Bearer ${accessToken},${refreshToken}`,
    },
  });
  clearUserSession();
  userAccountStore.reset();
  return result;
}
